import { solidstate } from ":setup/qstate";
import { global } from ":shared/app";
import { createEffect, createMemo, createResource, Match, Switch } from "solid-js";

import { Loader2 } from ":src/components/loaders";
import FiltrationModal from "./filtration-modal";
import ParticipantsTable from "./table";
import { scoring } from "./apis";
import { createInput, createSelect } from ":ui/form";
import type { SubmissionStatus } from "./_model";

export default function () {
  const [$details, $$details] = createResource(scoring.get);
  const $participants = createMemo(() => $details()?.participants);
  const $applied_filter = solidstate.create({} as { search?: string; status?: SubmissionStatus });
  const $filters = createMemo(() => {
    const result = {
      // search: ["title", "category"],
      statuses: ["pending", "done"] as SubmissionStatus[],
    };
    return result;
  });
  const Search = createInput(null);
  const FilterStatus = createSelect(null);

  createEffect(() => {
    const search = Search.control.value;
    $applied_filter.set((s) => ({ ...s, search: search }));
  });
  createEffect(() => {
    const status = FilterStatus.control.value;
    $applied_filter.set((s) => ({ ...s, status: status }));
  });

  return (
    <section class="flex flex-col w-full h-full px-2 py-2">
      <h1 class="text-xl  font-600 text-black z-1 capitalize <sm:(text-22px)">Participants</h1>
      <div class="flex flex-row w-full justify-between items-center gap-2 py-2 <sm:(!flex-col !gap-x-0)">
        <Search.Input autocomplete="search" class="form-input" placeholder="Search by name..." />
        <FilterStatus.Select
          class="form-select !w-30% <sm:(!w-full)"
          placeholder="Filter By Status..."
          options={$filters().statuses}
          allowClearSelected
        />
      </div>
      <Switch>
        <Match when={$details.loading}>
          <Loader2 msg="Loading Submissions..." />
        </Match>
        <Match when={$details.error}>error occured while loading membres {$details.error}</Match>
        <Match when={$participants()} keyed>
          <ParticipantsTable
            participants={$participants()}
            filter={{ search: $applied_filter.value.search, status: $applied_filter.value.status }}
            onItemClicked={({ item, itemIndex }) => {
              global.store.actions.popop.pushModal({
                title: "Filter Individual",
                startExpanded: true,
                element({ actions }) {
                  return (
                    <FiltrationModal
                      details={$details}
                      idx={itemIndex()}
                      onSubmit={async ({ index, scores }) => {
                        const participant = $details().participants[index];
                        return scoring.postOrPut({ participant, scores }).then(({ filtration_id, total }) => {
                          const _filtration_id = filtration_id ?? "ERROR";
                          const _total = total ?? "ERROR";
                          $$details.mutate((s) => {
                            const participants = [...s.participants];
                            let history = [...s.history];
                            if (!history.includes(participant.id)) {
                              history = [...history, participant.id];
                            }
                            // since track is not in criteria keys we can assume they're all numbers
                            for (const key of $details().c_keys) {
                              participant.scores[key].score = scores[key] as number;
                            }
                            participant.filtration_id = _filtration_id as number;
                            participant.scores.total.score = _total as number;
                            participant.filtration_total = _total as number;
                            participant.track.answer = scores.track as any;
                            //
                            participants[index] = participant;
                            return { ...s, history, participants };
                          });
                          global.store.actions.toast.pushToast({
                            type: "success",
                            message: "Filtration Submitted!",
                          });
                          actions.forceRefresh();
                        });
                      }}
                    />
                  );
                },
              });
            }}
          />
        </Match>
      </Switch>
    </section>
  );
}
